import i18n from "i18next";
import { initReactI18next } from 'react-i18next';

import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import { translationEN } from "./locales/EN/translationEN";
import { translationHR } from "./locales/HR/translationHR";
import { tosEN } from "./locales/EN/tosEN";
import { tosHR } from "./locales/HR/tosHR";
import { privacyEN } from "./locales/EN/privacyEN";
import { privacyHR } from "./locales/HR/privacyHR";
import { cookiesEN } from "./locales/EN/cookiesEN";
import { cookiesHR } from "./locales/HR/cookiesHR";
import { simpleEN } from "./locales/EN/simpleEN";
import { simpleHR } from "./locales/HR/simpleHR";
import { headerEN } from "./locales/EN/headerEN";
import { headerHR } from "./locales/HR/headerHR";
import { docInfoEN } from "./locales/EN/docInfoEN";
import { docInfoHR } from "./locales/HR/docInfoHR";
import { detailedEN } from "./locales/EN/detailedEN";
import { detailedHR } from "./locales/HR/detailedHR";
import { homeEN } from "./locales/EN/homeEN";
import { homeHR } from "./locales/HR/homeHR";
import { getPdfHR } from "./locales/HR/getPdfHR";
import { getPdfEN } from "./locales/EN/getPdfEN";
import { modalEN } from "./locales/EN/modalEN";
import { modalHR } from "./locales/HR/modalHR";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    //lng = 'hr',
    fallbackLng: 'en',

    whitelist: [
      'hr', 'en'
    ],

    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    },

    resources: {
      hr: {
        translations: translationHR,
        tos: tosHR,
          privacy: privacyHR,
          cookies: cookiesHR,
        simple: simpleHR,
        header: headerHR,
        docInfo: docInfoHR,
        detailed: detailedHR,
        home: homeHR,
        modal: modalHR,
        getPdf: getPdfHR
      },
      en: {
        translations: translationEN,
        tos: tosEN,
          privacy: privacyEN,
          cookies: cookiesEN,
        simple: simpleEN,
        header: headerEN,
        docInfo: docInfoEN,
        detailed: detailedEN,
        home: homeEN,
        modal: modalEN,
        getPdf: getPdfEN
      }
    },
    // have a common namespace used around the full app
    ns: ["translations", "tos", "simple", "privacy", "cookies"],
    defaultNS: "translations"
  });

export default i18n;